import { render, staticRenderFns } from "./TeaserSection.vue?vue&type=template&id=3981543a&"
import script from "./TeaserSection.vue?vue&type=script&lang=js&"
export * from "./TeaserSection.vue?vue&type=script&lang=js&"
import style0 from "./TeaserSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports